(function () {
  function initInfiniteScroll() {
    var grid = document.getElementById('product-grid') || document.getElementById('Slider-collection');
    var wrapper = document.querySelector('.pagination-wrapper');
    if (!grid || !wrapper) return;

    var loading = false;
    var done = false;

    // Hide the numbered pagination visually (kept in DOM for SEO/fallback)
    wrapper.style.display = 'none';

    var sentinel = document.createElement('div');
    sentinel.className = 'infinite-scroll-sentinel';
    sentinel.style.height = '1px';
    wrapper.parentNode.insertBefore(sentinel, wrapper);

    var status = document.createElement('div');
    status.className = 'infinite-scroll-status';
    status.setAttribute('role', 'status');
    wrapper.parentNode.insertBefore(status, wrapper);

    function getNextUrl() {
      var w = document.querySelector('.pagination-wrapper');
      if (!w) return null;
      var nextLink = w.querySelector('.pagination__item--next');;
      return nextLink ? nextLink.getAttribute('href') : null;
    }

    function loadNext() {
      if (loading || done) return;
      var nextUrl = getNextUrl();
      if (!nextUrl) { done = true; return; }

      loading = true;
      status.textContent = 'Loading more…';

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid') || doc.getElementById('Slider-collection');
          var newWrapper = doc.querySelector('.pagination-wrapper');

          if (newGrid) {
            var items = newGrid.querySelectorAll('.grid__item');
            items.forEach(function (item) { grid.appendChild(item); });
          }

          // Replace the current pagination wrapper with the fetched one so the next URL updates
          var currentWrapper = document.querySelector('.pagination-wrapper');
          if (newWrapper && currentWrapper) {
            newWrapper.style.display = 'none';
            currentWrapper.parentNode.replaceChild(newWrapper, currentWrapper);
          } else {
            done = true;
          }

          if (!getNextUrl()) { done = true; status.textContent = ''; }
          else { status.textContent = ''; }

          loading = false;
        })
        .catch(function () {
          // On error, restore the numbered pagination so users aren't stuck
          loading = false;
          done = true;
          var w = document.querySelector('.pagination-wrapper');
          if (w) w.style.display = '';
          status.textContent = '';
        });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadNext();
      }, { rootMargin: '600px 0px' }); // trigger 600px before reaching the bottom
      observer.observe(sentinel);
    } else {
      // Fallback for very old browsers: show normal pagination
      wrapper.style.display = '';
    }
  }

  if (document.readyState !== 'loading') initInfiniteScroll();
  else document.addEventListener('DOMContentLoaded', initInfiniteScroll);
})();